module.exports = __webpack_public_path__ + "static/img/play.774a876.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/play.png
// module id = cUGd
// module chunks = 1